module.exports = __webpack_public_path__ + "img/truck2.6f31f217.png";